import { ProcurementApprovalsDataGetRequest } from '../../../infrastructure';

async function ProcurementApprovalsDataGet(event) {
    const procurementApprovals = await ProcurementApprovalsDataGetRequest(event);
    return procurementApprovals;
}

export default ProcurementApprovalsDataGet;
